import { FieldMetadata, useInputControl } from '@conform-to/react'
import { z } from 'zod'

import { IconOfficeChair } from '~/components'
import { SimplifiedMultiSelect } from '~/components/ui/input/select/shadcn-multi-select'

export const officeTypeMultiSelectFormSchema = z.object({
  officeTypes: z.array(z.string()),
})

export const partialOfficeTypeMultiSelectFormSchema =
  officeTypeMultiSelectFormSchema.partial()

type OfficeType = z.infer<typeof officeTypeMultiSelectFormSchema>['officeTypes']

type Options = React.ComponentProps<typeof SimplifiedMultiSelect>['options']

export const useOfficeTypeForm = (
  meta: FieldMetadata<OfficeType>,
  changeWatchedOfficeTypes?: (officeTypes: string[]) => void,
) => {
  const control = useInputControl<OfficeType>({
    ...meta,
    initialValue: Array.isArray(meta?.initialValue)
      ? meta.initialValue.filter((val): val is string => val !== undefined)
      : [],
  })

  const value = Array.isArray(control.value) ? control.value : []

  const onChange = (officeTypes: string[]) => {
    changeWatchedOfficeTypes?.(officeTypes)
    control.change(officeTypes)
  }

  return { value, onChange, name: meta.name }
}

type Props = {
  name: string
  options: Options
  ariaLabel?: string
  value: string[]
  onChange: (value: string[]) => void
}

export const OfficeTypeMultiSelectForm = ({
  name,
  ariaLabel,
  options,
  value,
  onChange,
}: Props) => {
  return (
    <SimplifiedMultiSelect
      ariaLabel={ariaLabel}
      hideSelectAll={false}
      isClearable
      maxCount={10}
      name={name}
      onValueChange={onChange}
      options={options}
      placeholder="オフィスタイプを選択"
      placeholderIcon={<IconOfficeChair />}
      singleLine
      value={value}
    />
  )
}
